export const VIEWER_REPORT_ALLOCATION_MODEL_LIST = 'VIEWER_REPORT_ALLOCATION_MODEL_LIST'
export const VIEWER_REPORT_ALLOCATION_SEARCH = 'VIEWER_REPORT_ALLOCATION_SEARCH'
export const VIEWER_REPORT_ALLOCATION_PAGINATION = 'VIEWER_REPORT_ALLOCATION_PAGINATION'
export const VIEWER_REPORT_ALLOCATION_DROP_DOWN_SEARCH_TYPE = 'VIEWER_REPORT_ALLOCATION_DROP_DOWN_SEARCH_TYPE'
